// A picked image often arrives as `<origin>/share?file=<X>`. The backend's reference
// resolver only turns a /share URL into an image when X is an S3 path; when X is an
// external URL (e.g. a Salsify CDN link) it fails and Gemini gets no product image.
// Unwrap to the raw URL in that case so the backend fetches it directly. (POR-13385)
// Pure (no imports) so it can be verified with `node --test`. (POR-14685)
export function unwrapShareUrl(url) {
  if (typeof url !== 'string' || !url.includes('/share?')) return url;
  const m = url.match(/[?&]file=([^&]+)/);
  if (!m) return url;
  const inner = decodeURIComponent(m[1]);
  return /^https?:\/\//i.test(inner) ? inner : url;
}
